import Image from 'next/image'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  href: string
  photoCount?: number
  photoUrl: string | undefined
}

const NoPhoto = () => {
  return (
    <svg
      fill='currentColor'
      className='text-zinc-200 dark:text-zinc-600 aspect-5/1 sm:aspect-16/10 bg-zinc-100 dark:bg-transparent'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='-24 -24 72 72'
    >
      <title>No Photo Available</title>
      <path
        d='M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default function CardPhoto({ className, href, photoCount, photoUrl }: Props) {
  return (
    <div className={twMerge('border-b relative', className)}>
      {(photoCount || 0) > 0 && (
        <div className='absolute top-6 right-0 pl-4 pr-3 py-1.5 bg-zinc-700/50 text-white rounded-l-full flex items-center'>
          <span className='text-xs'>{photoCount}</span>
        </div>
      )}
      <Link href={href} prefetch={true}>
        {photoUrl ? (
          <Image
            width={480}
            height={480}
            src={photoUrl}
            alt='Photo'
            priority={true}
            unoptimized={true}
            className='pointer-events-none aspect-16/10 max-h-72 w-full object-cover m-auto'
          />
        ) : (
          <NoPhoto />
        )}
      </Link>
    </div>
  )
}
